<h5 class="text-primary-text">Internal UI Config</h5>

<div class="p-16 border-1 border-solid rounded-lg">
  <div class="info">
    <ng-container *ngTemplateOutlet="getCustomers().length === 0 ? loading : uiConfig"> </ng-container>
    <ng-template #uiConfig>
      <div class="label m-0">UI Layout:</div>

      <nz-select class="w-full" [(ngModel)]="customerType">
        <nz-option nzValue="ENERGY" nzLabel="Energy"></nz-option>
        <nz-option nzValue="MOBILITY" nzLabel="Mobility"></nz-option>
        <nz-option nzValue="MODELS" nzLabel="Models"></nz-option>
      </nz-select>

      <div class="label">Customer:</div>
      <nz-select
        [(ngModel)]="selectedCustomer"
        class="w-full"
        nzAllowClear
        [nzMaxTagCount]="8"
        [nzMaxTagPlaceholder]="tagPlaceHolder"
        nzMode="default"
        nzPlaceHolder="Please select"
        (ngModelChange)="setSelectedCustomer($event)"
        nzShowSearch
      >
        <nz-option *ngFor="let customer of getCustomers()" [nzLabel]="customer" [nzValue]="customer"> </nz-option>
      </nz-select>

      <div class="label">Systems:</div>

      <nz-select
        [(ngModel)]="selectedSystemBks"
        class="w-full"
        nzAllowClear
        [nzDropdownRender]="renderTemplate"
        [nzMaxTagCount]="8"
        [nzMaxTagPlaceholder]="tagPlaceHolder"
        nzMode="multiple"
        nzPlaceHolder="Please select"
        [(nzOpen)]="isSystemSelectOpen"
      >
        <nz-option-group *ngFor="let customer of getCustomers()" [nzLabel]="customer">
          <nz-option
            *ngFor="let system of availableSystemsPerCustomer[customer]"
            [nzLabel]="system.systemName"
            [nzValue]="system.customerBk + '/' + system.systemBk"
          ></nz-option>
        </nz-option-group>
      </nz-select>

      <div class="label">Product Package:</div>
      <nz-select [(ngModel)]="selectedProductPackage" class="w-full" nzAllowClear nzPlaceHolder="As delivered per system">
        <nz-option *ngFor="let productPackage of listAllProductPackages()" [nzLabel]="productPackage" [nzValue]="productPackage">
        </nz-option>
      </nz-select>

      <div class="label">Solutions:</div>
      <nz-select
        [(ngModel)]="selectedSolutionFlags"
        class="w-full"
        nzAllowClear
        [nzMaxTagCount]="8"
        [nzMaxTagPlaceholder]="tagPlaceHolder"
        nzMode="multiple"
        nzPlaceHolder="Please select"
        (ngModelChange)="setSelectedSolutions($event)"
      >
        <nz-option *ngFor="let solution of listAllSolutions()" [nzLabel]="solution" [nzValue]="solution"> </nz-option>
      </nz-select>

      <div class="label">Feature Flags:</div>
      <nz-select
        [(ngModel)]="selectedFeatureFlagsKeys"
        class="w-full"
        nzAllowClear
        [nzMaxTagCount]="8"
        [nzMaxTagPlaceholder]="tagPlaceHolder"
        nzMode="multiple"
        nzPlaceHolder="Please select"
        (ngModelChange)="setFeatureFlags($event)"
      >
        <nz-option *ngFor="let featureFlag of listAllFeatureFlags()" [nzLabel]="featureFlag" [nzValue]="featureFlag"> </nz-option>
      </nz-select>

      <ng-template #renderTemplate>
        <nz-divider></nz-divider>
        <div class="select__footer">
          <a (click)="selectAll()"> Select all</a>
        </div>
      </ng-template>
    </ng-template>

    <ng-template #tagPlaceHolder let-selectedList>and {{ selectedList.length }} more selected</ng-template>
    <ng-template #loading>
      <twaice-fe-progress-spinner spinnerText="Loading..."></twaice-fe-progress-spinner>
    </ng-template>
  </div>

  <div class="flex justify-end mt-16 gap-8">
    <button nz-button nzType="default" (click)="resetConfig()">Reset Config</button>

    <button nz-button nzType="primary" [disabled]="deliveredProductPackages === null" (click)="applyConfig()">
      Save & Apply Config
    </button>
  </div>
</div>
